import $api from "@/frontend/shared/api/axios";
import { CompetitorsSchema, TCompetitorsSchema, TParsingStatus } from "@/libs/models/portfolio-companies";

type TCompetitorsResponse = {
  data: TCompetitorsSchema;
  meta: {
    parsingStatus: TParsingStatus;
  };
};

export async function getPortfolioCompanyCompetitors(portfolioCompanyId: number) {
  const response = await $api.get<TCompetitorsResponse>(
    `/portfolio-companies/${portfolioCompanyId}/competitor-companies`
  );

  const parsedData = CompetitorsSchema.parse(response.data.data);
  const result = {
    status: response.data.meta.parsingStatus,
    data: parsedData
  };
  return result;
}
